import { useMemo } from "react";
import { CmsNewsArticle, toNewsFeed } from "./newsFeed";
import { useGetCmsIssuers } from "./useGetCmsIssuers";

interface UseGetCmsNewsFeedResult {
  loading: boolean;
  error: Error | null;
  data: CmsNewsArticle[] | undefined;
}

/**
 * Every issuer's news as one feed.
 *
 * The CMS has no news endpoint — news arrives embedded in each issuer — so this
 * rides the issuer list the issuers page has already cached rather than costing
 * a request of its own.
 */
export const useGetCmsNewsFeed = (): UseGetCmsNewsFeedResult => {
  const { loading, error, data: issuers } = useGetCmsIssuers();

  const data = useMemo(
    () => (issuers ? toNewsFeed(issuers) : undefined),
    [issuers]
  );

  return { loading, error: error ?? null, data };
};
